// Translations organized by pages for better maintainability
const translations = {
  registration: {
    // Headers
    title: '註冊成為我們的會員',
    subtitle: '完成註冊，即可獲得LINE Points！(數量有限，兌完為止)',
    linePointsText: '',

    // Form Labels
    name: '姓名',
    phoneNumber: '手機',
    email: '電子信箱',
    dob: '出生日期',
    referralCode: '推薦碼',

    // Placeholders
    namePlaceholder: '姓名',
    phonePlaceholder: '例如  0901-234-567',
    emailPlaceholder: '例如 name@email.com',
    dobPlaceholder: '例如  26/09/2002',
    referralCodePlaceholder: '輸入推薦碼​',

    // Radio/Checkbox Labels
    everTried: '您近一年內喝過白蘭氏鷄精嗎?',
    isParent: '您有小孩嗎?',
    gender: '性別?',
    occupation: '職業',
    occupationPlaceholder: '職業',
    acceptPolicy: '* 我接受',
    policyText: '隱私權政策與服務條款',
    marketingConsent: '我同意品牌於合理範圍內蒐集、處理及利用本人之個人資料，用於產品資訊、優惠活動、行銷通知、市場調查與數據分析，以提供更符合需求的服務與產品',

    // OTP
    otp: '手機驗證碼',
    otpPlaceholder: '請輸入驗證碼',
    sendOtp: '發送驗證碼',
    resendOtp: '重新發送',
    otpSentSuccess: '驗證碼已發送',
    otpVerifyError: '驗證碼驗證失敗',
    sendOtpError: '發送驗證碼失敗',
    otpNotSent: '請先發送驗證碼',
    otpRequired: '請輸入手機驗證碼',

    // Buttons
    submitButton: '繼續',

    // Error Messages
    registerError: '註冊時發生錯誤',
  },

  login: {
    loaderText: 'TW Loader',
    loginFailed: '登入失敗。請再試一次。',
    loginRequestFailed: '登入請求失敗',
    errorInLoggingIn: '登入時發生錯誤',
    errorInLineInitialization: 'LINE初始化錯誤',
  },

  mobileOtp: {
    title: '手機號碼驗證',
    description: '請確認或更新您的手機號碼，並完成驗證碼驗證。',
    verifyOtp: '驗證驗證碼',
    verifySuccess: '手機號碼驗證成功',
  },

  menu: {
    home: '首頁',
    rewards: '獎勵',
    upload: '掃描發票',
    vouchers: '錢包',
    profile: '其他',
  },

  home: {
    // Greeting card
    hello: '你好 !',
    drinkBrandEarnPoints: '喝白蘭氏鷄精，天天健康換現金',
    goldenEggAlt: 'Golden Egg',
    // Status card
    chickenStatusAlt: 'Chicken Status',
    chickenStatusLabel: '小鷄狀態',
    // PointsCard
    brandsPoint: "健康幣",
    chanceToWinThisMonth: '活動辦法',
    linePoints: 'Line Points',
    expiresOn: '過期於',
    pointsHistory: '健康幣紀錄',
    receiptsHistory: '發票登錄紀錄',
    coinAlt: 'Coin',
    linePointsIconAlt: 'Line Points icon',
    // Menu
    receiptUploadAlt: 'Receipt Upload',
    receiptUpload: '登錄發票',
    missionCenterAlt: 'Mission Center',
    missionCenter: '任務牆',
    rewardsCenterAlt: 'Rewards Center',
    rewardsCenter: '獎勵中心',
    // Registration rewards modal
    registrationRewardsTitle: '恭喜獲得 LINE POINTS 1 點',
    // Line points modal
    lineNotificationTitle: '第一瓶鷄精 白蘭氏買單',
    linePointsImgAlt: 'Line Points',
    lineNotificationDesc: '首次登錄發票，即可獲得LINE POINTS 49點或79點或200點 (活動內容詳見任務牆；一人限領取一次；數量有限、兌完為止)​',
    lineNotificationBtn: '首次登錄發票',
    // Chicken stage modal
    chickenStageNotificationTitle: '孵化你的小鷄吧！',
    chichenStageNotificationDesc: '探索任務，讓小鷄成長吧！',
    //Chicken Stage Modal
    chickenStage1NotificationTitle: '你的蛋裂開了…​ 🐣小鷄即將誕生​',
    chickenStage1NotificationBtn: '哦！好像有動靜…​',
    chickenStage2NotificationTitle: '恭喜! 小雞孵化成功',
    chickenStage2NotificationBtn: '快回去看看​',
    // Carousel
    banner: 'Banner',
    // Chicken feed notification
    chickenFeedNotificationDesc: '獲得健康幣1點 \n 記得每天喝鷄精，維持思緒清晰',
    chickenFeedAlreadyFedMessage: '今天已餵食，明天再回來！\n記得每天喝鷄精，維持思緒清晰\n還可以拿健康幣喔～',
    chickenFeedNotificationBtn: '查看我的健康幣',
  },

  uploadReceipt: {
    selectInvoiceType: '選擇發票類型',
    electronicInvoice: '電子發票',
    enterVehicleInformation: '手機載具',
    traditionalInvoice: '傳統發票',
    electronic: '電子發票',
    vehicle: '手機載具',
    traditional: '傳統發票',
    uploadReceiptTitle: '登錄發票',
    invoiceNumber: '發票號碼',
    invoiceDate: '發票日期',
    invoiceRandomNumber: '發票隨機碼',
    invoiceNumberPlaceholder: 'e.g. AA12345678',
    invoiceDatePlaceholder: 'e.g. 12-04-2025',
    invoiceRandomNumberPlaceholder: 'e.g. 9990',
    uploadImageHere: '上傳照片',
    review: '確認資訊',
    confirmSubmission: '確認提交',
    ensureDataAccurate: '請確保以下資料正確無誤。',
    invoicePhoto: '發票照片​',
    uploadReceiptImage: '發票照片​',
    submit: '提交​',
    uploadAgain: '重新上傳​',
    invalidInvoiceNumber: '請輸入正確的發票號碼，如：AA12345678',
    invalidRandomNumber: '請輸入正確的隨機碼，如：9990',
    qrDateExtractError: '無法從 QR Code 讀取發票日期',
    noQRDetected: "系統無法偵測，請拍照和手動輸入",
    qrParseError: 'QR Code 掃描失敗，請重新掃描或改為手動輸入',
    qrParseSuccess: 'QR Code 掃描成功',
    extractDataError: "抓取發票信息失敗​ 請手動輸入信息​",
    qrUnableToRetrieveData: "系統無法偵測，請拍照和手動輸入",
    extractDataSuccess: '資料擷取成功',
    uploadSuccess: '發票上傳成功',
    uploadFailed: '發票上傳失敗。請再試一次。',
    uploadSuccessMessage: "您的發票已順利提交，我們正在為您處理。 ​",
    uploadFailedMessage: "發票上傳失敗​",
    reuploadReceipt: "重新上傳​",
    completeOtherMissions: "完成其他任務​",
    backToHome: "返回首頁​",
    noDataToSubmit: "No data to submit",
    imageRequired: '請上傳發票照片',
    mobileBarcode: "手機條碼",
    mobileBarcodePlaceholder: "e.g. /SRZ1234",
    mobileBarcodeVerificationCode: "手機驗證碼",
    mobileBarcodeVerificationCodePlaceholder: "e.g. 1234567",
    invalidMobileBarcode: "Please enter a valid mobile barcode",
    chooseTheWay: "選擇方式",
    scanQR: "掃描 QR code",
    manuallyEnter: "手動輸入",
    uploadImage: "上傳發票",
    fileUpload: "檔案上傳​",
    camera: "相機​",
  },

  qrScanner: {
    placeReceiptInBox: '請掃描左側QR code'
  },

  missionCenter: {
    dailyTasks: '任務'
  },

  receiptHistory: {
    receiptHistory: '發票登錄紀錄',
    searchPlaceholder: '請至少輸入3 個字進行搜尋',
    approved: '已核准',
    rejected: '未通過',
    date: '日期',
    receipt: '發票號碼',
    status: '狀態',
    action: '待完成',
    uploadCertificate: '上傳兌換證明',
    installmentTitle: '說明:',
    installmentDescription: '登錄之發票需足以證明交易行為已完成，包含實際購買及產品領取。若為線上購買並採分批取貨之情形，除登錄之發票外，需另提供可佐證商品已完成兌換或領取之相關證明文件，始符合活動參加資格。如為分批取貨或使用虛擬卷，除發票外，需另行上傳兌換證明以供審核。',
    installmentRefundIntro:
      '此商品一組3入，原價 NT$597，特價 NT$295，單件原價 NT$199，退款金額試算如下：',
    installmentRefundLine1:
      '已兌換 + 已轉贈共 0 件，欲退貨 3 件，退款 NT$295。',
    installmentRefundLine2:
      '已兌換 + 已轉贈共 1 件，欲退貨 2 件，退款 NT$96。',
    installmentRefundLine3:
      '已兌換 + 已轉贈共 2 件，欲退貨 1 件，退款 NT$0。（小於0）',
    noDataFound: '查無資料',
    sort: '排序',
    newest: '新',
    oldest: '舊',
    default: '預設',
    rejectedReason: '未通過原因',
    statusAccepted: '已核准',
    statusRejected: '未通過',
    statusInProgress: '審核中',
  },

  validation: {
    required: '請填寫相關資訊',
    phoneRequired: '請輸入正確的手機號碼',
    emailRequired: '請輸入有效的電子郵件地址',
    dobRequired: '年齡須滿 6 歲以上',
    phoneFormat: '請輸入以 09開頭的有效手機號碼',
    selectAtLeastOne: '請選擇至少一項',
    acceptPolicy: '請同意隱私權政策與服務條款',
    mobileExists: '此手機號碼已被使用​',
    fileType: '請上傳 PNG、JPEG 或 JPG 檔案。',
    fileSize: '檔案大小需小於 5MB。',
  },

  common: {
    clearAll: '全部清除​',
    applyFilter: '套用篩選​',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    submit: '送出​',
    failedToFetchFormOptions: '無法取得表單選項',
    genericError: '系統發生錯誤。造成不便敬請見諒，請稍後再試。',
  },

  profile: {
    profileAlt: 'Profile',
    points: '共獲得健康幣',
    receipts: '上傳發票數量',
    rewardHistory: '健康幣兌換紀錄',
    termsAndConditions: '使用條款',
    contactBrandPoints: "健康幣相關問題",
    rewardAlt: 'Reward',
    newsIconAlt: 'News Icon',
    mailIconAlt: 'Mail Icon',
    cancelMembershipLink: '取消會員',
    cancelMembershipTitle: '取消會員',
    cancelMembershipWarning: '取消會員後，您目前累積的所有會員權益將一併失效',
    cancelMembershipChoice: '若您確定要取消會員，請選擇是否同時刪除您的個人資料',
    deleteDataOnCancel: '取消會員並刪除我的資料',
    cancelMembershipButton: '取消會員',
    back: '返回',
    updateProfileTitle: '更新個人資料',
    updateSuccess: '個人資料更新成功',
    close: '關閉​',
    errorUpdatingProfile: '更新個人資料時發生錯誤',
    customerCare: '客服中心​',
  },

  termsConditions: {
    title: '使用條款​',
    homeTitle: '活動辦法​',
    missionTitle: '活動辦法'
  },

  cancelledMembership: {
    title: '會員已取消',
    memberIdLabel: '會員編號',
    description: '您的會員已取消。如需恢復會員，請聯絡白蘭氏客服中心：0800-077-999（週一至週五9:00-17:00）',
    blockedUserAlt: 'Blocked user',
  },

  locked: {
    title: '帳號已暫時鎖定',
    memberIdLabel: '會員編號',
    description: '因安全驗證失敗次數過多，您的帳號已被鎖定。如需協助，請聯絡白蘭氏客服中心：0800-077-999（週一至週五9:00-17:00）',
    imageAlt: '帳號已鎖定',
    popupDescription:
      '為保障您的帳號安全，目前您的帳號已暫時受到保護，於48小時內無法使用相關功能。如需協助，請聯絡客服專線：02-25171326 #17，服務時間：週一至週五 10:00～17:00。',
    gotIt: '我知道了',
    pageLine1: '為保障您的帳號安全，目前您的帳號已暫時受到保護。',
    pageLine2: '如需協助，請聯絡客服。',
  },

  rewardHistory: {
    expiringPoints: '即將過期的健康幣​',
    pointsExpiringAfter: '點健康幣將於',
    expiringDate: '後到期​',
    expiryDate: '有效期限​',
    expiry: '效期至​',
    redeemedPoints: "健康幣歷史紀錄",
    expiredPoints: '過期健康幣',
    vouchers: '獎勵歷史紀錄​',
    type: '類別​',
    month: '月份',
    year: '年份',
    noRewardsToDisplay: '目前沒有可顯示的獎勵',
    noRewardsDetailsFound: '查無獎勵詳細資訊',
    errorFetchingVoucher: '取得獎勵券時發生錯誤',
  },

  vouchers: {
    code: 'Code :',
    clickHereToRedeem: '兌換​',
    issuedOn: '發放日期​:',
    expiry: '有效日期 :',
    codeCopiedToClipboard: '已複製',
    rewardName: '恭喜您獲得{{rewardName}}折價券獎項，請複製折扣碼：',
    shopeeDesc: '可立即使用！',
    momoDesc: '須先前往歸戶（會員中心＞折價券＞加入序號進行歸戶）：',
  },

  rewards: {
    expiringPoints: '健康幣過期於',
    details: '詳情',
    allBrandsPoints: "所有健康幣點數",
    pointsRedemptionHistory: '健康幣兌換紀錄',
    sortLowHigh: '低 – 高',
    sortHighLow: '高 – 低',
    insufficientPoints: "健康幣不足",
    noRewardsToDisplay: '目前沒有可顯示的獎勵',
    expiry: '有效期限​',
    rewardDollarAlt: 'Reward Dollar',
    rewardImageAlt: 'Reward image',
    rewardCategoriesTitle: '獎項類別​',
    allCategories: '所有類別',
  },

  rewardDetails: {
    pointsRequired: '兌換所需健康幣​',
    terms: '使用條款​',
    pointsLabel: "健康幣{{points}}點​",
    submitLabel: "使用健康幣{{points}}點兌換​",
    redeem: 'Redeem',
    redeemSuccessMessage: '已使用健康幣{{points}}點成功兌換 {{productName}}',
    redeemLimitReachedMessage: '本折價券限兌換一次。後續將持續發放新折價券，歡迎持續留意關注。',
    backToHome: '返回首頁​',
    viewMyVouchers: '查看獎勵​',
    noRewardDetailsFound: '查無獎勵詳細資訊',
    errorRedeeming: '兌換獎勵時發生錯誤',
    requestFailed: 'Request failed',
    pointsGainedAlt: 'Points gained',
    outOfStockAlt: 'Out of stock',
  },

  deliveryInfo: {
    title: '配送資訊',
    points: 'Points',
    address: '地址',
    addressPlaceholder: '請輸入有效地址',
    successTitle: '已成功送出',
    successSubMessage: "我們將於1個月工作天內寄送至您的地址",
    redeemMore: '兌換更多',
    backToHome: '返回首頁',
    giftAlt: 'Gift',
    submit: '送出'
  },

  watchAd: {
    successHeader: '觀看廣告完成!',
    message: '影片任務已完成。',
    pointsLabel: '獲得 {{points}} 健康幣​',
    coinAlt: 'Coin',
    next: '下一個​',
    redeemPoints: '兌換健康幣​',
    errorFetchingVideo: '取得廣告影片時發生錯誤',
    errorSubmittingMission: '提交任務時發生錯誤',
    submitFailed: '提交觀看廣告失敗'
  },

  feedback: {
    healthCoin: '健康幣',
    submit: '送出',
    proceed: '返回任務',
    backToRewards: '領取 LINE POINTS',
    title: '完成啦！',
    subtitle: '感謝您的回饋，幫助我們持續進步！',
    // footerText: '感謝您的分享，獎勵已入帳！',
    answerRequired: '請完成所有題目後再送出。',
    fetchError: '載入問卷時發生錯誤',
    noDataFound: '查無資料',
  },

  quiz: {
    title: '挑戰成功！',
    subtitle: '答對了，太棒了！',
    footerText: '繼續加油，明天再來挑戰！',
    answerRequired: '請選擇答案後再確認。',
    backToRewards: '查看我的健康幣',
    confirmAnswer: '確認答案',
    ReturnToTask: '再答一次 ',
    fetchError: '載入問答時發生錯誤',
    noDataFound: '查無資料',
  }
};

// Type for translation keys
type TranslationKey =
  | `registration.${keyof typeof translations.registration}`
  | `login.${keyof typeof translations.login}`
  | `mobileOtp.${keyof typeof translations.mobileOtp}`
  | `menu.${keyof typeof translations.menu}`
  | `home.${keyof typeof translations.home}`
  | `uploadReceipt.${keyof typeof translations.uploadReceipt}`
  | `qrScanner.${keyof typeof translations.qrScanner}`
  | `missionCenter.${keyof typeof translations.missionCenter}`
  | `receiptHistory.${keyof typeof translations.receiptHistory}`
  | `validation.${keyof typeof translations.validation}`
  | `common.${keyof typeof translations.common}`
  | `profile.${keyof typeof translations.profile}`
  | `cancelledMembership.${keyof typeof translations.cancelledMembership}`
  | `locked.${keyof typeof translations.locked}`
  | `rewardHistory.${keyof typeof translations.rewardHistory}`
  | `vouchers.${keyof typeof translations.vouchers}`
  | `rewards.${keyof typeof translations.rewards}`
  | `rewardDetails.${keyof typeof translations.rewardDetails}`
  | `deliveryInfo.${keyof typeof translations.deliveryInfo}`
  | `watchAd.${keyof typeof translations.watchAd}`
  | `termsConditions.${keyof typeof translations.termsConditions}`
  | `feedback.${keyof typeof translations.feedback}`
  | `quiz.${keyof typeof translations.quiz}`;

const getNestedValue = (obj: any, path: string): string => {
  const keys = path.split('.');
  let result = obj;
  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return path;
    }
  }
  return typeof result === 'string' ? result : path;
};

export const t = (key: TranslationKey): string => {
  return getNestedValue(translations, key);
};

export default translations;
